import React from "react";
import { AuthProvider } from "./AuthContext";
import { AppDataProvider } from "./AppDataContext";
import { VariableDataProvider } from "./VariableDataContext";

export const ContextProvider = ({ children }) => {
  return (
    <AuthProvider>
      <AppDataProvider>
        <VariableDataProvider>{children}</VariableDataProvider>
      </AppDataProvider>
    </AuthProvider>
  );
};
